/* cf-post-caps-rings.js — 2026-09-26
 * Pete's standing rule (19 & 23 Sep 2026): every IN-GROUND post gets ONE post cap and ONE
 * dress ring, colour-matched. Base-mount posts ("W/BASE & CAP") already include the cap
 * built into the product and must NOT get an extra cap or ring.
 *
 * Defect fixed: blade.js, flat-top.js and perfmesh-calc.js add in-ground posts (e.g.
 * "In-Ground Post (50x50x1800mm)" 49321) but never add a matching cap or dress ring.
 * Evidence: Josh's blade plan CF-BLAD-1-442c30c3, 10 in-ground posts, no caps/rings —
 * website showed $3,385.50, correct quote was $3,454.14.
 *
 * Approach: runtime patch, NOT a source edit. window.glassCalculator on blade/flat-top/
 * PerfMesh pages is the live, DOM-bound instance for that page (2026-09-01 correction in
 * the click-fencing-calculators vault note) — its constructor.prototype is reachable and
 * wrappable, exactly like the existing cf-*.js patches. Each file's own post-adding method
 * is wrapped so the ORIGINAL post logic is completely untouched; this only reads
 * state.quoteBreakdown afterwards for the lines that method just added and appends the
 * cap + ring lines under the SAME 'Posts & Accessories' category every file already uses
 * for its post line (or, on flat-top, immediately after 'Posts' in categoryDisplayOrder —
 * both files list 'Posts & Accessories' right after the post category, so no display-order
 * change was needed).
 *
 * Colour -> SKU map (Pete's 26 Sep correction — Monument gets the BLACK cap, never a
 * monument-coloured one; dress rings stay colour-matched):
 *   satin-black -> cap 49325, ring 49326
 *   white       -> cap 49962, ring 49938
 *   monument    -> cap 49325 (BLACK, not 49961), ring 49939
 * Classic Cream (flat-top only — blade/PerfMesh don't offer it) has no cap/ring variant on
 * the store. Per instruction: do not invent one. Reported as a $0, no-SKU breakdown line
 * instead of a real product line, and no cap/ring is added.
 *
 * Pricing: window.CF_PRICE(sku) — the same live-price / price-lock mechanism every other
 * line in these files uses (cf-sku-prices.js + cf-calc-price-lock.js). All six SKUs here
 * ARE in the price lock's locked list (cap 127c / ring 688c) as of 2026-09-26, so CF_PRICE
 * already returns the locked figure when the lock applies — this file never bypasses it.
 * Fallback prices (used only if CF_PRICE is unavailable) are the live store prices at
 * verification time: cap $0.99, ring $6.52.
 *
 * 2026-10-25 — BASE-MOUNT posts get ONE raised post base cover each (Pete's rule,
 * rules/click/products/aluminium). Found on Jack's CF-1042 (PerfMesh 3500 mm, 1 gate, base
 * mount, Satin Black = 3 x 49838 and no cover); Blade and Flat Top had the same gap. The
 * "Post with Base and Cap" products (49838/49941/49942 1300, 49839/49944/49945 1600,
 * 49896/49947/49948 1900) include the cap and base plate but not the cover.
 * Cover colour follows the fence: Satin Black 49971, Satin White 49950, Monument 49951
 * ($6.87 each at the time). Unlike the cap/ring lines, the cover total is added to the
 * method's return value so state.quote agrees with the breakdown.
 */
(function () {
  if (window.__cfPostCapsRingsInstalled) return;
  window.__cfPostCapsRingsInstalled = true;

  var CAP_SKUS  = { 'satin-black': '49325', 'white': '49962', 'monument': '49325' };
  var RING_SKUS = { 'satin-black': '49326', 'white': '49938', 'monument': '49939' };
  var FALLBACK_CAP_PRICE  = 0.99;
  var FALLBACK_RING_PRICE = 6.52;
  var COVER_SKUS = { 'satin-black': '49971', 'white': '49950', 'monument': '49951' };
  var FALLBACK_COVER_PRICE = 6.87;
  var BASE_POST_SKUS = { '49838':1, '49941':1, '49942':1, '49839':1, '49944':1, '49945':1, '49896':1, '49947':1, '49948':1 };

  function cfPrice(sku, fallback) {
    try {
      var c = (typeof window.CF_PRICE === 'function') ? window.CF_PRICE(sku) : null;
      return (c != null && c > 0) ? c / 100 : fallback;
    } catch (e) { return fallback; }
  }
  function cfVariant(sku, gc) {
    try {
      var map = (gc && gc.shopifyData && gc.shopifyData.skuVariantMap) || {};
      if (map[sku]) return map[sku];
      return (typeof window.CF_VARIANT === 'function') ? (window.CF_VARIANT(sku) || null) : null;
    } catch (e) { return null; }
  }

  // Mirrors each file's own resolveSectionColour() raw-value computation (before it
  // collapses to satin-black/white/monument), so classic-cream can be told apart from
  // satin-black — resolveSectionColour() itself never returns 'classic-cream'.
  function rawColour(gc, section) {
    try {
      var raw = (section && section.color)
        || (gc.state.sameForAll ? (gc.state.shared && gc.state.shared.color) : null)
        || (document.getElementById('mesh-color') && document.getElementById('mesh-color').value)
        || 'satin-black';
      return String(raw).toLowerCase();
    } catch (e) { return 'satin-black'; }
  }

  function colourSlug(gc, section) {
    try { return gc.resolveSectionColour(section); } catch (e) { return 'satin-black'; }
  }

  // After the original post-adding method has run, look at the lines it just pushed
  // (from startLen to the new end of quoteBreakdown) for the in-ground post line(s) it
  // added for THIS section — includes the normal post line and the raked/2400 outer-post
  // line when both are in-ground, and includes gate posts because they are already
  // counted into those same lines' quantities by the original code.
  function addCapsAndRings(gc, section, startLen, category) {
    try {
      var bd = gc.state.quoteBreakdown;
      if (!bd || !bd.length) return;

      var inGroundQty = 0;
      for (var i = startLen; i < bd.length; i++) {
        var line = bd[i];
        if (!line) continue;
        if (line.item && /^In-Ground (Post|Raked Post)\b/.test(line.item)) {
          inGroundQty += Number(line.quantity) || 0;
        }
      }
      if (inGroundQty <= 0) return;

      var raw = rawColour(gc, section);
      if (raw.indexOf('cream') !== -1 || raw.indexOf('classic') !== -1) {
        // Report only — no Classic Cream cap/ring variant exists on the store.
        bd.push({
          category: category,
          item: 'Post Cap & Dress Ring (' + inGroundQty + ' in-ground post' + (inGroundQty === 1 ? '' : 's') +
                ') — Classic Cream not stocked, supply separately',
          sku: null,
          quantity: 0,
          unitPrice: 0,
          totalPrice: 0,
          variantId: null
        });
        return;
      }

      var slug = colourSlug(gc, section);
      var capSku  = CAP_SKUS[slug]  || CAP_SKUS['satin-black'];
      var ringSku = RING_SKUS[slug] || RING_SKUS['satin-black'];
      var capPrice  = cfPrice(capSku,  FALLBACK_CAP_PRICE);
      var ringPrice = cfPrice(ringSku, FALLBACK_RING_PRICE);
      var capVariant  = cfVariant(capSku,  gc);
      var ringVariant = cfVariant(ringSku, gc);

      var capLine = {
        category: category,
        item: 'Post Cap (50x50mm)',
        sku: capSku,
        quantity: inGroundQty,
        unitPrice: capPrice,
        totalPrice: capPrice * inGroundQty,
        variantId: capVariant
      };
      var ringLine = {
        category: category,
        item: 'Post Dress Ring (50x50mm)',
        sku: ringSku,
        quantity: inGroundQty,
        unitPrice: ringPrice,
        totalPrice: ringPrice * inGroundQty,
        variantId: ringVariant
      };
      bd.push(capLine, ringLine);

      // Flat top pushes cartItems directly (its post/bracket lines do the same) —
      // mirror that so the cap/ring reach the real cart the same way its own post line does.
      if (gc.__cfPushCartDirect) {
        gc.state.cartItems.push({ variantId: capVariant,  quantity: inGroundQty, price: capPrice,  sku: capSku,  title: capLine.item });
        gc.state.cartItems.push({ variantId: ringVariant, quantity: inGroundQty, price: ringPrice, sku: ringSku, title: ringLine.item });
      }

      if (window.console && console.log) {
        console.log('[cf-post-caps-rings] ' + inGroundQty + ' in-ground post(s), colour ' + slug +
          ' -> cap ' + capSku + ' @ $' + capPrice.toFixed(2) + ', ring ' + ringSku + ' @ $' + ringPrice.toFixed(2));
      }
    } catch (e) {
      if (window.console && console.error) console.error('[cf-post-caps-rings] error', e);
    }
  }

  // One raised base cover per base-mount post in the lines the wrapped method just added.
  // Returns the dollars added so the wrapper can add them to the method's own total.
  function addBaseCovers(gc, section, startLen, category) {
    try {
      var bd = gc.state.quoteBreakdown;
      if (!bd || !bd.length) return 0;

      var qty = 0;
      for (var i = startLen; i < bd.length; i++) {
        var line = bd[i];
        if (!line) continue;
        if (BASE_POST_SKUS[String(line.sku || '')] || (line.item && /^Base Mount (Raked )?Post\b/i.test(line.item))) {
          qty += Number(line.quantity) || 0;
        }
      }
      if (qty <= 0) return 0;

      var raw = rawColour(gc, section);
      if (raw.indexOf('cream') !== -1 || raw.indexOf('classic') !== -1) {
        bd.push({ category: category, item: 'Raised Post Base Cover (' + qty + ' base-mount post' + (qty === 1 ? '' : 's') +
                  ') — Classic Cream not stocked, supply separately', sku: null, quantity: 0, unitPrice: 0, totalPrice: 0, variantId: null });
        return 0;
      }

      var slug = colourSlug(gc, section);
      var sku = COVER_SKUS[slug] || COVER_SKUS['satin-black'];
      var price = cfPrice(sku, FALLBACK_COVER_PRICE);
      var variant = cfVariant(sku, gc);
      var total = Math.round(price * qty * 100) / 100;
      var cover = {
        category: category,
        item: 'Raised Post Base Cover (50x50mm)',
        sku: sku,
        quantity: qty,
        unitPrice: price,
        totalPrice: total,
        variantId: variant
      };
      bd.push(cover);
      if (gc.__cfPushCartDirect) {
        gc.state.cartItems.push({ variantId: variant, quantity: qty, price: price, sku: sku, title: cover.item });
      }
      if (window.console && console.log) {
        console.log('[cf-post-caps-rings] ' + qty + ' base-mount post(s), colour ' + slug + ' -> cover ' + sku + ' @ $' + price.toFixed(2));
      }
      return total;
    } catch (e) {
      if (window.console && console.error) console.error('[cf-post-caps-rings] cover error', e);
      return 0;
    }
  }
  function plus(result, add) {
    return (typeof result === 'number' && add) ? Math.round((result + add) * 100) / 100 : result;
  }

  function tryInstall(tries) {
    tries = tries || 0;
    var gc = window.glassCalculator;
    var proto = gc && gc.constructor && gc.constructor.prototype;
    if (!proto) {
      if (tries < 60) return setTimeout(function () { tryInstall(tries + 1); }, 250);
      return;
    }
    if (proto.__cfPostCapsRingsPatched) return;
    proto.__cfPostCapsRingsPatched = true;

    // Blade — dedicated method, category 'Posts & Accessories' already used for its post line.
    if (typeof proto.calculatePostAndCapCosts === 'function') {
      var origBlade = proto.calculatePostAndCapCosts;
      proto.calculatePostAndCapCosts = function (section) {
        var startLen = (this.state.quoteBreakdown || []).length;
        var result = origBlade.call(this, section);
        addCapsAndRings(this, section, startLen, 'Posts & Accessories');
        return plus(result, addBaseCovers(this, section, startLen, 'Posts & Accessories'));
      };
      console.log('[cf-post-caps-rings] installed on blade.js (calculatePostAndCapCosts)');
    }

    /* 2026-09-26 (break test F13, Pete: "you tell me from jg price list"). Flat top priced its
       raked posts from a hard-coded table ($52.46 / $63.51 / $59.59, from an older cost) while
       Blade reads the live store price for the SAME SKUs ($61.16 / $74.04 / $69.49 — James Glen
       cost $31.14 / $37.70 / $36.74 ex-GST, the same +78.5% markup as every other post). The cart
       then came out ABOVE the quote, so cf-real-line-items fell back to one placeholder line and
       the order lost its parts list. Price them from the store, like Blade, with their variant. */
    var FT_RAKE_SKUS = { '49323':1, '49932':1, '49933':1, '49896':1, '49947':1, '49948':1, '49839':1, '49944':1, '49945':1 };
    function fixFlatTopRakePosts(gc, startLen, result) {
      try {
        var bd = gc.state.quoteBreakdown || [], delta = 0;
        for (var i = startLen; i < bd.length; i++) {
          var l = bd[i];
          if (!l || !FT_RAKE_SKUS[String(l.sku || '')]) continue;
          var cents = (typeof window.CF_PRICE === 'function') ? window.CF_PRICE(String(l.sku)) : null;
          if (!(cents > 0)) continue;
          var unit = Math.round(cents) / 100, qty = Number(l.quantity) || 0;
          var before = Number(l.totalPrice) || 0;
          l.unitPrice = unit;
          l.totalPrice = Math.round(unit * qty * 100) / 100;
          if (!l.variantId && typeof window.CF_VARIANT === 'function') l.variantId = window.CF_VARIANT(String(l.sku)) || null;
          delta += l.totalPrice - before;
        }
        return (Number(result) || 0) + delta;
      } catch (e) { return result; }
    }

    // Flat top — dedicated method, category 'Posts'; this file also pushes cartItems
    // directly for its own post/bracket lines, so do the same for the cap/ring.
    if (typeof proto.calculatePostCosts === 'function') {
      var origFlatTop = proto.calculatePostCosts;
      proto.calculatePostCosts = function (section, calculation) {
        var startLen = (this.state.quoteBreakdown || []).length;
        this.__cfPushCartDirect = true;
        var result = origFlatTop.call(this, section, calculation);
        result = fixFlatTopRakePosts(this, startLen, result);
        addCapsAndRings(this, section, startLen, 'Posts & Accessories');
        result = plus(result, addBaseCovers(this, section, startLen, 'Posts & Accessories'));
        this.__cfPushCartDirect = false;
        return result;
      };
      console.log('[cf-post-caps-rings] installed on flat-top.js (calculatePostCosts)');
    }

    // PerfMesh — posts are built inline inside calculatePanelCosts (no dedicated post
    // method to wrap), so the whole function is wrapped. Nothing inside it is touched;
    // only the lines it just added to quoteBreakdown are read afterwards. Category
    // 'Posts & Accessories' already used for its post line.
    if (typeof proto.calculatePanelCosts === 'function' && !proto.calculatePostAndCapCosts && !proto.calculatePostCosts) {
      var origPerfMesh = proto.calculatePanelCosts;
      proto.calculatePanelCosts = function (section, calculation) {
        var startLen = (this.state.quoteBreakdown || []).length;
        var result = origPerfMesh.call(this, section, calculation);
        addCapsAndRings(this, section, startLen, 'Posts & Accessories');
        return plus(result, addBaseCovers(this, section, startLen, 'Posts & Accessories'));
      };
      console.log('[cf-post-caps-rings] installed on perfmesh-calc.js (calculatePanelCosts)');
    }
  }

  tryInstall(0);
})();
